import styled from "styled-components";

export const LayoutContainer = styled.div`
  width: auto;
  min-height: 100vh;
  align-items: center;
  background-color: #000;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 0;
  position: relative;
`;

export const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
`;

export const MainContent = styled.main`
  flex: 1;
  width: 100%;
`;

export const FooterBlank = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: 400px;
  justify-content: center;
  overflow: visible;
  padding: 0;
  pointer-events: none;
  position: relative;
  user-select: none;
  width: 100%;
  z-index: -1;

  @media (max-width: 768px) {
    height: 300px;
  }

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    border-radius: inherit;
    pointer-events: none;
  }
`;

export const FixedContainer = styled.div`
  align-items: center;
  background-color: #f76000;
  bottom: 0;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  left: 0;
  overflow: hidden;
  padding: 0;
  position: fixed;
  width: 100%;
  z-index: 4;
`;

export const ButtonContainer = styled.div`
  flex: none;
  height: auto;
  position: relative;
  width: 200px;

  @media (max-width: 768px) {
    width: 160px;
  }
`;

export const DemoButton = styled.a`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 50px;
  justify-content: center;
  overflow: hidden;
  padding: 14px 32px;
  position: relative;
  text-decoration: none;
  background-color: rgb(247, 96, 0);
  box-shadow: rgba(146, 222, 232, 0) 0px 0px 20px -5px;
  width: 100%;
  opacity: 1;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 20px;
    width: 100%;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 30px,
      rgba(0, 0, 0, 0.15) 30px,
      rgba(0, 0, 0, 0.15) 60px
    );
    background-size: 200% 200%;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  &:hover::before {
    opacity: 1;
    animation: diagonalStripe 8s linear infinite;
  }

  @keyframes diagonalStripe {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 200% 200%;
    }
  }
`;

export const ButtonText = styled.div`
  flex: none;
  height: auto;
  position: relative;
  user-select: none;
  white-space: pre;
  width: auto;
  z-index: 2;
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-shrink: 0;
  transform: none;
  opacity: 1;
  overflow: hidden;
  background: transparent;
`;

export const ButtonLabel = styled.p`
  font-family: "Inter Display", "Inter Display Placeholder", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: rgb(13, 13, 13);
  text-transform: uppercase;
  position: relative;
  display: inline-block;
  z-index: 2;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ButtonHighlight = styled.div`
  bottom: 0;
  flex: none;
  left: -10px;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 1px;
  z-index: 0;
  background-color: rgb(247, 96, 0);
  transform: none;
  transform-origin: 50% 50% 0px;
`;

export const TopButton = styled.a`
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
  transition: opacity 0.3s ease;

  @media (max-width: 768px) {
    bottom: 65px;
    right: 15px;
  }
`;

export const TopButtonContainer = styled.div`
  width: 60px;
  height: 60px;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s ease;
  visibility: hidden;

  &.visible {
    opacity: 1;
    transform: scale(1);
    visibility: visible;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

export const TopButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TopButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;
